var React = require('react');

function BotSaysColored (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Assets","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"id":"image/bot-says","fill":"#A2CE70","stroke":"#89BF4B","strokeWidth":"2"},React.createElement("path",{"d":"M34,6 L34,22.8888889 C34,25.0980279 32.209139,26.8888889 30,26.8888889 L20.1628746,26.8888889 L11.48078,34 L11.48078,26.8888889 L6,26.8888889 C3.790861,26.8888889 2,25.0980279 2,22.8888889 L2,6 C2,3.790861 3.790861,2 6,2 L30,2 C32.209139,2 34,3.790861 34,6 Z","id":"Rectangle-314"}))));
}

BotSaysColored.defaultProps = {"width":"36px","height":"36px","viewBox":"0 0 36 36"};

module.exports = BotSaysColored;

BotSaysColored.default = BotSaysColored;
